module.exports = __webpack_public_path__ + "media/images/wedding/15-0f77f2c4a371562d3c1758b85076d6cf.jpg";